import React, { Component } from "react"
import {  Hits } from 'react-instantsearch';
import classNames from "classnames"
import HitsList from "./hitsList"
import CategoriesList from "./categoriesList"

class Results extends Component {
          constructor(props) {
            super(props);
            this.state = {
                query: "",
                isActive: ""
            };
        }

        mapCategoryNameToObject = categoryName => window.productCategories.find( cat => cat.title === categoryName )
    	render() {
		return (
                <div className={classNames("typeahead-results", { "is-active": this.props.isActive })}>
                    <div className="container">
                        <div className="typeahead-results__section">
                            <div className="typeahead-results__header">
                                <h4 className="typeahead-results__heading">Products</h4>
                                <a href={`/search?query=${this.state.query}`}>  view all  <svg><use xlinkHref="#solid-arrow-right" /></svg></a>
                            </div>
                             <Hits hitComponent={HitsList}  query={this.state.query}  />
                        </div>
                        <div className="typeahead-results__section">
                            <div className="typeahead-results__header">
                                <h5 className="typeahead-results__heading">Categories</h5>
                                <a href="/products"> view all <svg><use xlinkHref="#solid-arrow-right" /></svg> </a>
                            </div>
                                <CategoriesList query={this.state.query} {...this.props} /> 
                        </div>
                    </div>
                </div>
		)
	}
}
export default Results